import React, { useMemo, useContext } from 'react';

import { useGetAppConfigurationOnRender, useGetValidationRulesOnRender } from '@api';
import { IRuntimeAppSettings } from '@model';
import { ReactFCC } from '@types';

import { defaultApplicationSettings } from './model';

export interface IApplicationContext {
  applicationSettings: IRuntimeAppSettings;
}

const defaultContextValue: IApplicationContext = {
  applicationSettings: defaultApplicationSettings,
};

export const ApplicationRuntimeContext = React.createContext<IApplicationContext>(defaultContextValue);

export const ApplicationRuntimeContextProvider: ReactFCC = ({ children }) => {
  const { response: applicationSettingsResponse } = useGetAppConfigurationOnRender();
  const { response: validationRulesResponse } = useGetValidationRulesOnRender();

  const applicationSettings = useMemo(
    () => ({
      applicationSettings: {
        ...defaultApplicationSettings,
        ...applicationSettingsResponse?.data,

        validationRules: validationRulesResponse && { ...validationRulesResponse },
      },
    }),
    [applicationSettingsResponse, validationRulesResponse],
  );

  return (
    <ApplicationRuntimeContext.Provider value={applicationSettings}>{children}</ApplicationRuntimeContext.Provider>
  );
};

export const useApplicationRuntimeContext = () => useContext(ApplicationRuntimeContext);
